
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"30","height":"30","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('g',{attrs:{"clip-path":"url(#clip-qa-w)","fill":"#fff"}},[_c('path',{attrs:{"d":"M27 19.242a7.782 7.782 0 00-4.267-6.929c-.08 5.71-4.71 10.34-10.42 10.42A7.781 7.781 0 0019.243 27a7.729 7.729 0 003.947-1.079l3.776 1.045-1.044-3.777A7.73 7.73 0 0027 19.242z","fill-opacity":".65"}}),_c('path',{attrs:{"d":"M21.328 12.164c0-5.053-4.11-9.164-9.164-9.164C7.111 3 3 7.11 3 12.164c0 1.647.438 3.25 1.27 4.658l-1.236 4.472 4.472-1.237a9.135 9.135 0 004.658 1.271c5.053 0 9.164-4.11 9.164-9.164zm-10.57-2.133H9.352a2.816 2.816 0 012.812-2.812 2.816 2.816 0 012.813 2.812 2.82 2.82 0 01-.915 2.076L12.867 13.2v1.097h-1.406V12.58l1.652-1.512a1.408 1.408 0 00-.948-2.444c-.776 0-1.407.63-1.407 1.406zm.703 5.672h1.406v1.406h-1.406v-1.406z"}})]),_c('defs',[_c('clipPath',{attrs:{"id":"clip-qa-w"}},[_c('path',{attrs:{"fill":"#fff","transform":"translate(3 3)","d":"M0 0h24v24H0z"}})])])])
          )
        }
      }
    